import React from 'react';
import { 
    TableContainer, 
    Table, 
    TableHead, 
    TableRow, 
    TableCell, 
    TableBody, 
    Skeleton,
    Box 
} from '@mui/material';

const ITUserActionTableSkeleton: React.FC = () => {
    return (
        <TableContainer
            sx={{
                borderRadius: '12px',
                backgroundColor: '#FAF9F9',
            }}
        >
            <Table>
                <TableHead>
                    <TableRow>
                        {['Action', 'Message', 'User', 'Roles', 'Timestamp'].map((head) => (
                            <TableCell
                                key={head}
                                sx={{
                                    color: '#49454F',
                                    fontWeight: 600,
                                    fontSize: '12px',
                                    borderBottom: 'none',
                                    backgroundColor: "#fff"
                                }}
                            >
                                {head}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Array.from({ length: 5 }).map((_, index) => (
                        <TableRow
                            key={index}
                            sx={{
                                backgroundColor: '#FAF9F9',
                                height: 56,
                                borderRadius: '12px',
                            }}
                        >
                            <TableCell>
                                <Skeleton
                                    variant="text"
                                    width={80}
                                    height={20}
                                    sx={{ backgroundColor: '#f0f0f0' }}
                                />
                            </TableCell>
                            <TableCell>
                                <Skeleton
                                    variant="text"
                                    width={120}
                                    height={20}
                                    sx={{ backgroundColor: '#f0f0f0' }}
                                />
                            </TableCell>
                            <TableCell>
                                <Skeleton
                                    variant="text"
                                    width={100}
                                    height={20}
                                    sx={{ backgroundColor: '#f0f0f0' }}
                                />
                            </TableCell>
                            <TableCell>
                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                    <Skeleton
                                        variant="rectangular"
                                        width={80}
                                        height={24}
                                        sx={{
                                            borderRadius: '6px',
                                            backgroundColor: '#f0f0f0'
                                        }}
                                    />
                                    <Skeleton
                                        variant="rectangular"
                                        width={100}
                                        height={24}
                                        sx={{
                                            borderRadius: '6px',
                                            backgroundColor: '#f0f0f0'
                                        }}
                                    />
                                </Box>
                            </TableCell>
                            <TableCell>
                                <Skeleton
                                    variant="text"
                                    width={90}
                                    height={20}
                                    sx={{ backgroundColor: '#f0f0f0' }}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ITUserActionTableSkeleton;
